import { useMemo } from "react";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryUserProfile } from "../../../query/users/queries";
import { queriesInternalAccounts } from "@query";
import { selectorHasPayerContextUser } from "../../../shared/selectors/selectorHasPayerContextUser";
import { selectorIsEnterpriseUser } from "../../../shared/selectors/selectorIsEnterpriseUser";

export const useRequiresBankingVerification = (): boolean => {
  const userId = useUserId();
  const queryUser = useQueryUserProfile(userId);
  const queryInternalAccounts =
    queriesInternalAccounts.listInternalAccounts.useQuery();

  return useMemo(() => {
    const user = queryUser.data;
    const internalAccounts = queryInternalAccounts.data;

    if (!user) {
      return false;
    }

    if (selectorHasPayerContextUser(user)) {
      return true;
    }

    if (selectorIsEnterpriseUser(user)) {
      return true;
    }

    if (
      internalAccounts?.data?.some(
        account => account.status === "Active" || account.status === "Pending"
      )
    ) {
      return true;
    }

    return false;
  }, [queryUser.data, queryInternalAccounts.data]);
};
